// extracted by mini-css-extract-plugin
export default {"admin-layout":"AdminLayout_admin-layout__3hOAa","content":"AdminLayout_content__L6ScH","main-content":"AdminLayout_main-content__8npkt"};